var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.9541H9V5.9541H11V7.9541ZM11 15.9541H9V9.9541H11V15.9541ZM10.01 20.9541C15.53 20.9541 20 16.4741 20 10.9541C20 5.4341 15.53 0.954102 10.01 0.954102C4.48 0.954102 0 5.4341 0 10.9541C0 16.4741 4.48 20.9541 10.01 20.9541ZM10 2.9541C14.42 2.9541 18 6.5341 18 10.9541C18 15.3741 14.42 18.9541 10 18.9541C5.58 18.9541 2 15.3741 2 10.9541C2 6.5341 5.58 2.9541 10 2.9541Z",
    fill: "#E9E9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeInfo);
export default __webpack_public_path__ + "static/media/CE-Info.ebba3d4010e2a6a074286a0a5417e739.svg";
export { ForwardRef as ReactComponent };